export class PODetailModel {
    action: string
    po_seq: string
    po_no: string
    code_name: string
    quantity: string
    qty: string
    container_type: string
    unit_cost: string
    unit_per_issue: string
    method_of_issue: string
    issue_container: string
    unit_per_container: string
    order_no: string
    item_no: string
    item_type: string
    container_cost: string
    vendor: string
    vendor_visible: string
    vendor_code: string
    manufacturer_code: string
    // details: string
    item_log: string
    qty_on_hand: string
    item_code: string
    qty_this_month: string
    edit_quantity: boolean
    edit_vendor_code: boolean
    edit_container_cost: boolean

    select: boolean
    private _details: string
    code_type: number
    code_no: number

    public get details(): string {
        return `${this.unit_per_issue} ${this.method_of_issue}/${this.issue_container} - ${this.unit_per_container} ${this.issue_container}/${this.container_type}`;
    }

    public set details(details: string) {
        this._details = details;
    }

    constructor(
        action: string,
        po_seq: string,
        po_no: string,
        code_name: string,
        quantity: string,
        qty: string,
        container_type: string,
        unit_cost: string,
        unit_per_issue: string,
        method_of_issue: string,
        issue_container: string,
        unit_per_container: string,
        order_no: string,
        item_no: string,
        item_type: string,
        container_cost: string,
        vendor_code: string,
        details: string,
        item_log: string,
        qty_on_hand: string,
        item_code: string,
        qty_this_month: string
    ) {
        this.action = action
        this.po_seq = po_seq
        this.po_no = po_no
        this.code_name = code_name
        this.quantity = quantity
        this.qty = qty
        this.container_type = container_type
        this.unit_cost = unit_cost
        this.unit_per_issue = unit_per_issue
        this.method_of_issue = method_of_issue
        this.issue_container = issue_container
        this.unit_per_container = unit_per_container
        this.order_no = order_no
        this.item_no = item_no
        this.item_type = item_type
        this.container_cost = container_cost
        this.vendor_code = vendor_code
        this.details = details
        this.item_log = item_log
        this.qty_on_hand = qty_on_hand
        this.item_code = item_code
        this.qty_this_month = qty_this_month
        this.action = ''
        this.edit_quantity = false
        this.edit_vendor_code = false
        this.select = false
    }
}